export default __webpack_public_path__ + "static/media/gold1.a6f83922.png";